function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".container" + shadowSelector + " {background: #f8f9fa;border-radius: 1rem;padding: var(--sds-g-spacing-5) 0;}.divider" + shadowSelector + " {margin-top: 1.5rem;border-width: 1px 0px;border-style: solid;border-color: #e5e5e5;width: 100%;padding-top: 0;margin-bottom: 1.5rem;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];